import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import { useEffect } from "react";
import { AdjustBanner, useShouldLoadAdjust } from "./AdjustBanner";
import { CustomBanner, useShouldLoadCustomBanner } from "./CustomBanner";
export const AppBanner = () => {
    const { isWebView } = useEnvironment();
    const shouldLoadAdjust = useShouldLoadAdjust();
    const { shouldLoad: shouldLoadCustomBanner, isDismissed: isCustomBannerDismissed, onDismiss: onCustomBannerDismiss, } = useShouldLoadCustomBanner();
    useEffect(() => {
        if (!shouldLoadCustomBanner) {
            onCustomBannerDismiss();
        }
    }, [shouldLoadCustomBanner, onCustomBannerDismiss]);
    if (isWebView)
        return null;
    return (_jsxs(_Fragment, { children: [shouldLoadAdjust && isCustomBannerDismissed && _jsx(AdjustBanner, {}), shouldLoadCustomBanner && !isCustomBannerDismissed && (_jsx(CustomBanner, { onDismissCallback: onCustomBannerDismiss }))] }));
};
